import { Users, Shield, Trophy, Calendar, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const groupOptions = [
  {
    icon: Users,
    title: "Freundesgruppen",
    description: "Trainiert gemeinsam mit Freunden und verbessert Technik, Spielformen und Abläufe im Team."
  },
  {
    icon: Shield,
    title: "Vereinstraining",
    description: "Individuelle Einheiten für Mannschaften und Vereine – angepasst an Alter, Niveau und Ziele."
  },
  {
    icon: Trophy,
    title: "Camps & Spezialtraining",
    description: "Intensive Fußball-Einheiten, Technik-Camps und besondere Trainingstage für Gruppen und Teams."
  }
];

export const GroupTrainingSection = () => {
  return (
    <section className="py-20 lg:py-28 bg-[#121212]" data-testid="group-training-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <p className="text-xs uppercase tracking-[0.2em] text-[#c1ff72] font-semibold mb-4">
            Für Teams & Vereine
          </p>
          <h2 className="font-['Bebas_Neue'] text-4xl md:text-5xl lg:text-6xl uppercase tracking-tighter text-white mb-6">
            TRAINING FÜR{" "}
            <span className="text-[#c1ff72]">GRUPPEN & VEREINE</span>
          </h2>
          <p className="text-[#A1A1AA] text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            Ob Freundesgruppen, Mannschaften oder Vereins-Camps – individuelles Fußballtraining ist auch für Gruppen möglich.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {groupOptions.map((option) => (
            <div
              key={option.title}
              className="bg-[#1A1A1A] border border-white/5 p-8 hover:border-[#c1ff72]/30 transition-all duration-300 group"
            >
              <div className="w-14 h-14 bg-[#c1ff72]/10 flex items-center justify-center mb-6 group-hover:bg-[#c1ff72]/20 transition-colors">
                <option.icon className="w-7 h-7 text-[#c1ff72]" />
              </div>
              <h3 className="font-['Bebas_Neue'] text-2xl text-white mb-3">
                {option.title}
              </h3>
              <p className="text-[#A1A1AA] leading-relaxed">
                {option.description}
              </p>
            </div>
          ))}
        </div>

        {/* Note & CTA */}
        <div className="text-center">
          <p className="text-[#71717A] text-sm mb-6">
            Preise und Umfang individuell auf Anfrage.
          </p>
          <Link to="/buchen">
            <Button
              className="bg-[#c1ff72] hover:bg-[#d4ff9a] text-[#0A0A0A] font-semibold px-8 py-6 rounded-none transition-all duration-300 hover:shadow-[0_0_30px_rgba(193,255,114,0.4)] group"
              data-testid="group-training-cta"
            >
              <Calendar className="w-5 h-5 mr-2" />
              JETZT BUCHEN
              <ChevronRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default GroupTrainingSection;
